<template>
  <div id="survey-container">
    <usabilla-container v-slot="{ usabillaIsDoneLoading, widgetMounted }">
      <usabilla-widget
        v-if="usabillaIsDoneLoading"
        :widget-id="widgetId"
        :order-reference="referenceOrderID"
        @on-widget-mounted="widgetMounted"
      />
    </usabilla-container>
  </div>
</template>

<script>
import UsabillaContainer from '@/components/shared/feedback/UsabillaContainer'
import UsabillaWidget from '@/components/shared/feedback/UsabillaWidget'
export default {
  name: 'Survey',
  components: {
    UsabillaContainer,
    UsabillaWidget
  },
  props: {
    widgetId: {
      type: String,
      required: true
    },
    referenceOrderID: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
#survey-container {
  padding-top: 22px;
}
</style>
